export default __webpack_public_path__ + "static/media/swiftgpi.387c109a.jpg";